import type { GetRequestOptions, IFetchService } from "app/services/fetchService";

import type { AssignableUserDTO, AssignToUserRequestParams } from "../../types/common";

export default function createAssignToUsersApiService(fetchService: IFetchService) {
    return {
        fetchAssignableUsers(options?: GetRequestOptions): Promise<AssignableUserDTO[]> {
            return fetchService.get("/sales-api/account-users", undefined, options);
        },

        assignWebsitesToUser(params: AssignToUserRequestParams): Promise<void> {
            return fetchService.post("/sales-api/workspace/assign-opportunities", {
                AssigneeId: params.assigneeId,
                Domains: params.domains,
            });
        },
    };
}
